import React, { useState } from 'react';
import { AWS_CONFIG } from '../config/aws';

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 100, padding: 20,
};
const cardStyle = {
  padding: 24, maxWidth: 520, width: '100%',
  maxHeight: '90vh', overflowY: 'auto',
};
const labelStyle = {
  fontSize: '0.85rem', color: 'var(--text-muted)',
  display: 'block', marginBottom: 4,
};
const taStyle = {
  width: '100%', padding: '8px 12px',
  borderRadius: 'var(--radius)', border: '1px solid var(--border)',
  background: 'var(--bg)', color: 'var(--text)',
  fontSize: '0.9rem', resize: 'vertical', boxSizing: 'border-box',
};

function FaqForm({ title, faqId, initial, onClose, onSuccess, apiCall }) {
  const [form, setForm] = useState(initial);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const update = (f) => (e) => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(p => ({ ...p, [f]: val }));
  };
  const canSubmit = form.question.trim() && form.answer.trim() && !submitting;

  const handleSubmit = async () => {
    setSubmitting(true); setError('');
    try {
      const err = await apiCall(form);
      if (err) setError(err);
      else onSuccess();
    } catch (e) {
      setError(e.message || '서버 연결 실패');
    }
    setSubmitting(false);
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div className="card" onClick={e => e.stopPropagation()} style={cardStyle}>
        <h2 style={{ marginTop: 0, marginBottom: 16 }}>{title}</h2>
        {faqId && (
          <p style={{ fontSize: '0.8rem', color: 'var(--text-dim)', marginTop: 0, marginBottom: 16 }}>
            ID: <code>{faqId}</code>
          </p>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={labelStyle}>질문 *</label>
            <textarea style={{ ...taStyle, minHeight: 64 }} value={form.question}
              onChange={update('question')} autoFocus
              placeholder="예: 광택과 코팅의 차이는 무엇인가요?" />
          </div>
          <div>
            <label style={labelStyle}>답변 *</label>
            <textarea style={{ ...taStyle, minHeight: 120 }} value={form.answer}
              onChange={update('answer')}
              placeholder="답변을 입력하세요. Enter 개행이 그대로 표시됩니다." />
          </div>
          <div>
            <label style={labelStyle}>
              표시 순서
              <span style={{ color: 'var(--text-dim)', fontWeight: 400, marginLeft: 6 }}>
                (비워두면 자동)
              </span>
            </label>
            <input className="input" type="number" min="0"
              value={form.sortOrder} onChange={update('sortOrder')}
              placeholder="0, 1, 2 ..." style={{ width: 120 }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input id={`faqvis-${faqId || 'new'}`} type="checkbox"
              checked={form.visible} onChange={update('visible')}
              style={{ width: 16, height: 16, cursor: 'pointer' }} />
            <label htmlFor={`faqvis-${faqId || 'new'}`}
              style={{ ...labelStyle, marginBottom: 0, cursor: 'pointer' }}>
              바로 노출
            </label>
          </div>
          {error && <p style={{ color: '#ff5252', fontSize: '0.85rem', margin: 0 }}>{error}</p>}
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <button className="btn btn-outline" onClick={onClose} style={{ flex: 1 }}>취소</button>
            <button className="btn btn-primary" disabled={!canSubmit} onClick={handleSubmit}
              style={{ flex: 2, opacity: canSubmit ? 1 : 0.5 }}>
              {submitting ? '처리 중...' : (faqId ? '저장' : '추가')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AddFAQModal({ onClose, onCreated, getIdToken, serviceId, categoryLabel }) {
  const apiCall = async (form) => {
    const token = await getIdToken();
    const body = { question: form.question.trim(), answer: form.answer.trim(), visible: form.visible };
    if (form.sortOrder !== '') body.sortOrder = parseInt(form.sortOrder, 10) || 0;
    if (serviceId) body.serviceId = serviceId;
    const res = await fetch(`${AWS_CONFIG.apiUrl}/faqs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify(body),
    });
    if (!res.ok) { const d = await res.json().catch(() => ({})); return d.error || `생성 실패 (${res.status})`; }
    return null;
  };
  const title = categoryLabel ? `${categoryLabel} — 새 질문 추가` : '새 질문 추가';
  return (
    <FaqForm title={title} faqId={null}
      initial={{ question: '', answer: '', sortOrder: '', visible: true }}
      onClose={onClose} onSuccess={onCreated} apiCall={apiCall} />
  );
}

export function EditFAQModal({ faq, onClose, onSaved, getIdToken }) {
  const apiCall = async (form) => {
    const token = await getIdToken();
    const body = { question: form.question.trim(), answer: form.answer.trim(), visible: form.visible };
    if (form.sortOrder !== '') body.sortOrder = parseInt(form.sortOrder, 10) || 0;
    const res = await fetch(`${AWS_CONFIG.apiUrl}/faqs/${faq.faqId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify(body),
    });
    if (!res.ok) { const d = await res.json().catch(() => ({})); return d.error || `저장 실패 (${res.status})`; }
    return null;
  };
  return (
    <FaqForm title="질문 편집" faqId={faq.faqId}
      initial={{ question: faq.question || '', answer: faq.answer || '', sortOrder: faq.sortOrder != null ? String(faq.sortOrder) : '', visible: faq.visible !== false }}
      onClose={onClose} onSuccess={onSaved} apiCall={apiCall} />
  );
}
